import React from 'react';
import {connect} from "react-redux";
import CheckBox from "../../../PageLayout/CheckBox";
import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import {toggleArrayValue} from "../../../FeatureCreator/FeaturesFilters/filtersFunctions";
import {AccessRights} from "../../../../schemas/accessRightsModel";


const WizardClonePopupFabricatorsList = (props) => {

  const {fabricators} = props;
  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);
  const {selectedFabricators} = wizardPopupState;

  const onFabricatorClick = (fabricatorId) => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        selectedFabricators: toggleArrayValue(selectedFabricators, fabricatorId)
      }
    })
  }

  return (
    <div className="fabricators-popup-content">
      <ul className="ui-list">
        {fabricators.map((fabricator, entityIndex) => {
          // return (
          //   <li key={fabricator.id + '-' + entityIndex}
          //       onClick={() => console.log("entity", fabricator)}
          //       className={"sales-person-list__item" + (fabricator.isActive ? " sales-person-list__item--active" : "")}>
          //     <div className="table-cell">
          //       <div className="fabricators-popup-row">
          //         <div className="fabricators-popup-col">
          //           <CheckBox innerStyle="none"
          //                     checked={selectedFabricators.includes(fabricator.id)}
          //                     text={fabricator.companyName || fabricator.name}
          //                     onChecked={() => onFabricatorClick(fabricator.id)} />
          //         </div>
          //       </div>
          //     </div>
          //   </li>
          // )
          return (
            <li key={fabricator.id + '-' + entityIndex}
                onClick={() => console.log("entity", fabricator)}
                className={"sales-person-list__item" + (fabricator.isActive ? " sales-person-list__item--active" : "")}>
              <div className="table-cell ">
                <div className="fabricators-popup-row ">
                  <div className="fabricators-popup-col ">
                    <CheckBox innerStyle="none"
                              type={"tiny"}
                              checked={selectedFabricators.includes(fabricator.customerBaseId || fabricator.id)}
                              text=""
                              onChecked={() => onFabricatorClick(fabricator.customerBaseId || fabricator.id)} />
                    {fabricator.name || fabricator.companyName}
                  </div>
                </div>
              </div>
              {fabricator.dashboardEntity ? (
                <div className="table-cell ">
                  <div className="fabricators-popup-row ">
                    <div className="fabricators-popup-col ">
                      {fabricator.dashboardEntity}
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="table-cell ">
                <div className="fabricators-popup-row ">
                  <div className="fabricators-popup-col ">
                    {fabricator.email || (fabricator.emails ? fabricator.emails.toString() : "-")}
                  </div>
                </div>
              </div>
              <div className="table-cell ">
                <div className="fabricators-popup-row ">
                  <div className="fabricators-popup-col ">
                    {fabricator.companyName || (fabricator.fabricatorNames ? fabricator.fabricatorNames.join(', ') : '')}
                  </div>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {fabricators} = store;
  const AR = AccessRights.get(store);
  const isSiteAdmin = AR.isSiteAdmin(true);
  const {enabledEntities} = store.customers;

  return {
    fabricators: isSiteAdmin ? enabledEntities.data.rows.filter(row => {
      return row.dashboardEntity === "MasterFabricator" || row.dashboardEntity === "SiteAdmin"
    }) : fabricators.data.rows,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(WizardClonePopupFabricatorsList)
